import React from "react";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

import ReactDOM from "react-dom/client";

import Login from "./pages/public";
import Register from "./pages/public/register";
import reportWebVitals from "./reportWebVitals";
import { ThemeContextProvider } from "./contexts/ThemeContext";

import "./index.css";
import { QueryClient, QueryClientProvider } from "react-query";
import PasswordReset from "./pages/public/reset";
import ShopifyInstallLogin from "./pages/public/shopify";
import ShopifyVerify from "./pages/public/shopifyVerify";
import HelpLayout from "./pages/Help/HelpLayout";
import HelpHome from "./pages/Help";
import HelpCategory from "./pages/Help/HelpCategory";
import HelpPage from "./pages/Help/HelpPage";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// React Router: Append your pages to the router here
const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "register",
    element: <Register />,
  },
  {
    path: "shopify",
    children: [
      {
        path: "install",
        element: <ShopifyInstallLogin />,
      },
      {
        path: "verify",
        element: <ShopifyVerify />,
      },
    ],
  },
  {
    path: "password-reset",
    element: <PasswordReset />,
  },
  {
    path: "help",
    element: <HelpLayout />,
    children: [
      {
        index: true,
        element: <HelpHome />,
      },
      {
        path: ":categoryId",
        element: <HelpCategory />,
      },
      {
        path: ":categoryId/:pageId",
        element: <HelpPage />,
      },
    ],
  }
]);

const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeContextProvider>
        <RouterProvider router={router} />
      </ThemeContextProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
